import { useRef } from 'react'
import { kuiperClassNames } from '@opallabs/kuiper'
import { ContentTextInput } from '../../../../ContentTextInput'
import { addCaption } from '../staticText'
import { TextAreaWithAccountName } from '../TextAreaWithAccountName'
import { styles } from './styles'

interface Props {
  content: string
  contentCharacterLimit: number
  headline: string
  index: number
  onContentChange: (val: string, dest: string) => void
  postType: string
  readOnly: boolean
  truncate: boolean
  username: string
}

export const CarouselTextAreasWithAccount: React.FC<Props> = ({
  content = '',
  contentCharacterLimit,
  headline = '',
  index,
  onContentChange,
  postType,
  readOnly,
  truncate = false,
  username = '',
}) => {
  const adCaptionLimit = 80 - (username.length + (headline.length || 0))
  const truncateShouldShowCaption = truncate
    ? username.length + headline.length < adCaptionLimit
    : true
  const textFieldsRef = useRef<HTMLDivElement>(null)

  return (
    <div
      ref={textFieldsRef}
      className={kuiperClassNames(`${postType}-${index}`)}
    >
      <TextAreaWithAccountName
        postType={postType}
        index={index}
        content={postType.includes('ad') ? headline : content}
        display="mobileStream"
        readOnly={readOnly}
        placeholder={
          postType.includes('ad') ? 'Add headline...' : 'Add caption...'
        }
        contentCharacterLimit={
          postType.includes('ad') ? null : contentCharacterLimit
        }
        style={styles.getInput(postType.includes('ad'))}
        onContentChange={
          postType.includes('ad')
            ? (val: string) =>
                onContentChange(val, index?.toString() || 'headline')
            : (val: string) => onContentChange(val, 'content')
        }
        accountMeasurerStyle={styles.accountMeasurer}
        truncate={truncate}
        truncationLimit={80}
        username={username}
      />
      {postType.includes('ad') && truncateShouldShowCaption && (
        <div css={styles.adInput}>
          <ContentTextInput
            ariaLabel={`Carousel Text ${index}`}
            value={content}
            readOnly={readOnly}
            placeholder={addCaption}
            onChange={(val: string) => onContentChange(val, 'content')}
            truncate={truncate}
            characterLimit={
              contentCharacterLimit - (username.length + headline.length)
            }
            truncationLimit={adCaptionLimit}
            inputStyle={{ paddingTop: 0 }}
          />
        </div>
      )}
    </div>
  )
}
